import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusBadge',
})
export class StatusBadgePipe implements PipeTransform {
  transform(value: string): string {
    let bgClass = '';
    switch (value.toLowerCase()) {
      case 'active':
        bgClass = 'bg-green';
        break;
      case 'receiving':
        bgClass = 'bg-green';
        break;
      case 'paid':
        bgClass = 'bg-green';
        break;
      case 'completed':
        bgClass = 'bg-green';
        break;
      case 'accepted':
        bgClass = 'bg-green';
        break;
      case 'past':
        bgClass = 'bg-green';
        break;
      case 'vacant':
        bgClass = 'bg-green';
        break;
      case 'approved':
        bgClass = 'bg-green';
        break;
      case 'enrolled':
        bgClass = 'bg-green';
        break;
      case 'online':
        bgClass = 'bg-green';
        break;
      case 'yes':
        bgClass = 'bg-green';
        break;
      case 'confirmed':
        bgClass = 'bg-green';
        break;
      case 'no':
        bgClass = 'bg-danger';
        break;
      case 'empty':
        bgClass = 'bg-danger';
        break;
      case 'dispatch':
        bgClass = 'bg-danger';
        break;
      case 'occupied':
        bgClass = 'bg-danger';
        break;
      case 'cleared':
        bgClass = 'bg-amber';
        break;
      case 'endorsed':
        bgClass = 'bg-amber';
        break;
      case 'pending_verification':
        bgClass = 'bg-amber';
        break;
      case 'pending_verification':
        bgClass = 'bg-amber';
        break;
      case 'busy':
        bgClass = 'bg-amber';
        break;
      case 'logged_out':
        bgClass = 'bg-amber';
        break;
      case 'logged_in':
        bgClass = 'bg-green';
        break;
      case 'pending_payment':
        bgClass = 'bg-amber';
        break;
      case 'payment_pending':
        bgClass = 'bg-amber';
        break;
      case 'pending_approval':
        bgClass = 'bg-amber';
        break;
      case 'inactive':
        bgClass = 'bg-danger';
        break;
      case 'closed':
        bgClass = 'bg-danger';
        break;
      case 'cancelled':
        bgClass = 'bg-danger';
        break;
      case 'overstayed':
        bgClass = 'bg-danger';
        break;
      case 'un_paid':
        bgClass = 'bg-danger';
        break;
      case 'verification_failed':
        bgClass = 'bg-danger';
        break;
      case 'no':
        bgClass = 'bg-danger';
        break;
      case 'reversed':
        bgClass = 'bg-danger';
        break;
      case 'terminated':
        bgClass = 'bg-danger';
        break;
      case 'full':
        bgClass = 'bg-green';
        break;
      case 'open':
        bgClass = 'bg-green';
        break;
      case 'rejected':
        bgClass = 'bg-danger';
        break;
      case 'submitted':
        bgClass = 'bg-amber';
        break;
      case 'waitlisted':
        bgClass = 'bg-amber';
        break;
      case 'partial':
        bgClass = 'bg-amber';
        break;
      case 'suspended':
        bgClass = 'bg-amber';
        break;
      case 'pending':
        bgClass = 'bg-amber';
        break;
      case 'update':
        bgClass = 'bg-amber';
        break;
      case 'delete':
        bgClass = 'bg-danger';
        break;
      case 'failed':
        bgClass = 'bg-danger';
        break;
      case 'create':
        bgClass = 'bg-green';
        break;
      case 'true':
        bgClass = 'bg-green';
        break;
      case 'false':
        bgClass = 'bg-danger';
        break;
      case 'restore':
        bgClass = 'bg-green';
        break;
      default:
        bgClass = 'bg-dark';
    }

    return `<span class="badge ${bgClass} px-3 py-2">${value}</span>`;
  }
}
